export enum LOGOS {
  HELIPAGOS_SQUARED = '/assets/img/logo-helipagos-circular.png',
  HELIPAGOS_LARGE = '/assets/img/helipagos-color.png',
}
